// extracted by mini-css-extract-plugin
export var actions = "_4p-0";
export var actionsContainer = "_4p-6";
export var border = "_4p-1";
export var childFullHeight = "_4p-d";
export var collapse = "_4p-2";
export var content = "_4p-8";
export var contentChild = "_4p-c";
export var fullscreen = "_4p-a";
export var headerContainer = "_4p-3";
export var headerRow = "_4p-5";
export var hidePadding = "_4p-9";
export var noScrollX = "_4p-e";
export var noScrollY = "_4p-f";
export var optOutTopPadding = "_4p-b";
export var pagePadding = "_4p-7";
export var profile = "_4p-g";
export var profileContainer = "_4p-h";
export var profileImage = "_4p-i";
export var profileMain = "_4p-j";
export var profileSubtitle = "_4p-l";
export var profileTitle = "_4p-k";
export var tabsWrapper = "_4p-4";
export var title = "_4p-m";